function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-right: auto;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import PropTypes from 'prop-types';

var maxWidth = function maxWidth(props) {
  return props.maxWidth ? {
    maxWidth: "".concat(props.maxWidth, "px")
  } : {
    maxWidth: props.theme.maxContainerWidth
  };
};

var Container = styled.div(_templateObject(), maxWidth);
Container.propTypes = {
  maxWidth: PropTypes.number
};
Container.displayName = 'Container';
export default Container;